import {TheCageGameAssets} from "../TheCageGameAssets";

/**
 * Created by jonas on 2022-02-01.
 */

export class TheCageTextStyles {


    public static WIN_COUNT_UP = {
        fontName : TheCageGameAssets.BITMAP_FONT_WIN_COUNT_UP,
        fontSize : 312,
        tint : 0xffffff
    }

    public static WIN_CAP_COUNT_UP = {
        fontName : TheCageGameAssets.BITMAP_FONT_WIN_CAP_COUNT_UP,
        fontSize : 160,
        tint : 0xffffff
    }

    public static WIN_WAYS_BOTTOM_NAME = TheCageGameAssets.BITMAP_FONT_WAYS_WON;
    public static WIN_WAYS_TOP_NAME = TheCageGameAssets.BITMAP_FONT_WAYS_WON;

/*    static FREESPINS_WON = {
        fontName : OctagonGameAssets.BITMAP_FONT_FREESPIN_NUMBER,
        fontSize : 156,
        tint : 0xffffff
    }*/

}